export const useFrameFixed = (cb, opts = { fps: 120, max: 1 / 30 }) => {
  const accumulator = useRef(0);

  const { fps, max } = opts;
  const FIXED_TIME_STEP = 1 / fps;

  useFrame((state, delta) => {
    // Accumulate time
    accumulator.current += delta;

    // Cap accumulator to prevent spiral of death
    if (accumulator.current > max) {
      accumulator.current = max;
    }

    // Run physics updates with fixed time step
    while (accumulator.current >= FIXED_TIME_STEP) {
      cb(FIXED_TIME_STEP);
      accumulator.current -= FIXED_TIME_STEP;
    }
  });
};
